module.exports = __webpack_public_path__ + "media/images/pastel-purple-461dc909a4052a7cbc449a144939b60e.png";